<script>
  let {
    assetsPath = '/',
    onAiMounted = () => {},
    onArtboardChange = () => {},
  } = $props();
  import { onMount, untrack } from 'svelte';
  let aiBox;
  let aiBoxWidth = $state(undefined);
  let allArtboards = $state([]);
  let activeArtboard = $state(undefined);
  onMount(() => {
    allArtboards = Array.from(aiBox.querySelectorAll('.g-artboard'));
    onAiMounted();
  });
  $effect(() => {
    if (aiBoxWidth) {
      const currentArtboard = allArtboards.filter((artboard) => {
        const minWidth = parseFloat(artboard.dataset.minWidth);
        const maxWidth = parseFloat(artboard.dataset.maxWidth) || Infinity;
        return minWidth <= aiBoxWidth && maxWidth >= aiBoxWidth;
      })[0];
      if (currentArtboard?.id !== activeArtboard?.id) {
        activeArtboard = untrack(() => currentArtboard);
        onArtboardChange(activeArtboard);
      }
    }
  });
</script>

<div
  id="g-post14-refinery-box"
  class="ai2svelte"
  bind:this={aiBox}
  bind:clientWidth={aiBoxWidth}
>
  <!-- Artboard: xs -->
  <div
    id="g-post14-refinery-xs"
    class="g-artboard"
    style="max-width: 509px;aspect-ratio: 0.26829268292683;"
    data-aspect-ratio="0.268"
    data-min-width="0"
    data-max-width="509"
  >
    <div
      id="g-post14-refinery-xs-img"
      class="g-post14-refinery-xs-img g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/post14-refinery-xs.jpg);"
    ></div>
    <div
      id="g-ai0-2"
      class="g-text g-aiAbs g-aiPointText"
      style="top:3.1434%;margin-top:-18.7px;left:18.1916%;width:186px;"
    >
      <p class="g-pstyle1">Israeli strikes on Tehran</p>
      <p class="g-pstyle1">oil facilities</p>
    </div>
    <div
      id="g-ai0-3"
      class="g-text g-aiAbs g-aiPointText"
      style="top:19.4002%;margin-top:-9.6px;left:49.9376%;margin-left:-87px;width:174px;"
    >
      <p class="g-pstyle2">Oil refineries and depots</p>
    </div>
    <div
      id="g-ai0-4"
      class="g-text g-aiAbs"
      style="top:22.1138%;left:0.776%;width:95.7576%;"
    >
      <p class="g-pstyle3">
        On the night of March 7&ndash;8, 2026, Israeli airstrikes hit multiple
        fuel depots and refineries across Tehran and the neighboring Alborz
        province, igniting vast pools of crude oil and refined fuel.
      </p>
    </div>
    <div
      id="g-ai0-10"
      class="g-text g-aiAbs g-aiPointText"
      style="top:73.7938%;margin-top:-9.7px;left:40.7753%;width:84px;"
    >
      <p class="g-pstyle1">Acid rain</p>
    </div>
    <div
      id="g-ai0-7"
      class="g-text g-aiAbs"
      style="top:52.2764%;left:0.776%;width:95.7576%;"
    >
      <p class="g-pstyle3">
        The burning oil sent a towering black plume into the sky, releasing
        massive amounts of toxic hydrocarbons along with sulfur and nitrogen
        oxides into the lower atmosphere.
      </p>
    </div>
    <div
      id="g-ai0-11"
      class="g-text g-aiAbs g-aiPointText"
      style="top:88.3467%;margin-top:-9.7px;left:38.3603%;width:68px;"
    >
      <p class="g-pstyle5">Tehran</p>
    </div>
    <div
      id="g-ai0-12"
      class="g-text g-aiAbs"
      style="top:91.5447%;left:0.776%;width:96.9697%;"
    >
      <p class="g-pstyle3">
        As the toxic plume spread across Tehran, sulfur dioxide and nitrogen
        dioxide combined with moisture in the air, producing dangerous acid
        rain. Authorities warned residents to stay indoors as dense pollution
        and falling rain carried corrosive chemicals across the city.
      </p>
    </div>
    <div
      id="g-ai0-9"
      class="g-blackshadow g-aiAbs g-aiPointText"
      style="top:67.2898%;margin-top:-9.7px;left:27.0961%;width:173px;"
    >
      <p class="g-pstyle4">Dense pollution cloud</p>
    </div>
    <div
      id="g-ai0-6"
      class="g-blackshadow g-aiAbs g-aiPointText"
      style="top:35.745%;margin-top:-27.7px;left:78.2335%;width:67px;"
    >
      <p class="g-pstyle4">Toxic</p>
      <p class="g-pstyle4">smoke</p>
      <p class="g-pstyle4">plume</p>
    </div>
    <div
      id="g-ai0-5"
      class="g-numbersc g-aiAbs g-aiPointText"
      style="top:30.2606%;margin-top:-9.2px;left:6.0909%;margin-left:-15.5px;width:31px;"
    >
      <p class="g-pstyle0">2</p>
    </div>
    <div
      id="g-ai0-8"
      class="g-numbersc g-aiAbs g-aiPointText"
      style="top:67.1712%;margin-top:-9.2px;left:6.0909%;margin-left:-15.5px;width:31px;"
    >
      <p class="g-pstyle0">3</p>
    </div>
    <div
      id="g-ai0-1"
      class="g-numbersc g-aiAbs g-aiPointText"
      style="top:1.724%;margin-top:-9.2px;left:5.7879%;margin-left:-14.5px;width:29px;"
    >
      <p class="g-pstyle0">1</p>
    </div>
  </div>
  <!-- Artboard: sm -->
  <div
    id="g-post14-refinery-sm"
    class="g-artboard"
    style="min-width: 510px;max-width: 659px;aspect-ratio: 0.42148760330579;"
    data-aspect-ratio="0.421"
    data-min-width="510"
    data-max-width="659"
  >
    <div
      id="g-post14-refinery-sm-img"
      class="g-post14-refinery-sm-img g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/post14-refinery-sm.jpg);"
    ></div>
    <div
      id="g-ai1-2"
      class="g-text g-aiAbs g-aiPointText"
      style="top:19.7209%;margin-top:-9.6px;left:49.3216%;margin-left:-87px;width:174px;"
    >
      <p class="g-pstyle1">Oil refineries and depots</p>
    </div>
    <div
      id="g-ai1-3"
      class="g-text g-aiAbs"
      style="top:21.9835%;left:9.788%;width:79.8039%;"
    >
      <p class="g-pstyle2">
        On the night of March 7&ndash;8, 2026, Israeli airstrikes hit multiple
        fuel depots and refineries across Tehran and the neighboring Alborz
        province, igniting vast pools of crude oil and refined fuel.
      </p>
    </div>
    <div
      id="g-ai1-10"
      class="g-text g-aiAbs g-aiPointText"
      style="top:89.8069%;margin-top:-9.7px;left:41.8304%;width:68px;"
    >
      <p class="g-pstyle5">Tehran</p>
    </div>
    <div
      id="g-ai1-9"
      class="g-text g-aiAbs g-aiPointText"
      style="top:75.0136%;margin-top:-9.7px;left:43.3931%;width:84px;"
    >
      <p class="g-pstyle0">Acid rain</p>
    </div>
    <div
      id="g-ai1-6"
      class="g-text g-aiAbs"
      style="top:52.7273%;left:9.788%;width:78.8235%;"
    >
      <p class="g-pstyle2">
        The burning oil sent a towering black plume into the sky, releasing
        massive amounts of toxic hydrocarbons along with sulfur and nitrogen
        oxides into the lower atmosphere.
      </p>
    </div>
    <div
      id="g-ai1-11"
      class="g-text g-aiAbs"
      style="top:92.2314%;left:9.788%;width:78.2353%;"
    >
      <p class="g-pstyle2">
        As the toxic plume spread across Tehran, sulfur dioxide and nitrogen
        dioxide combined with moisture in the air, producing dangerous acid
        rain. Authorities warned residents to stay indoors as dense pollution
        and falling rain carried corrosive chemicals across the city.
      </p>
    </div>
    <div
      id="g-ai1-1"
      class="g-text g-aiAbs g-aiPointText"
      style="top:3.1954%;margin-top:-18.7px;left:28.7801%;width:186px;"
    >
      <p class="g-pstyle0">Israeli strikes on Tehran</p>
      <p class="g-pstyle0">oil facilities</p>
    </div>
    <div
      id="g-ai1-5"
      class="g-blackshadow g-aiAbs g-aiPointText"
      style="top:36.3359%;margin-top:-27.7px;left:67.6306%;width:67px;"
    >
      <p class="g-pstyle4">Toxic</p>
      <p class="g-pstyle4">smoke</p>
      <p class="g-pstyle4">plume</p>
    </div>
    <div
      id="g-ai1-8"
      class="g-blackshadow g-aiAbs g-aiPointText"
      style="top:68.402%;margin-top:-9.7px;left:34.5418%;width:173px;"
    >
      <p class="g-pstyle4">Dense pollution cloud</p>
    </div>
    <div
      id="g-ai1-4"
      class="g-numbersc g-aiAbs g-aiPointText"
      style="top:30.7608%;margin-top:-9.2px;left:20.9502%;margin-left:-15.5px;width:31px;"
    >
      <p class="g-pstyle3">2</p>
    </div>
    <div
      id="g-ai1-7"
      class="g-numbersc g-aiAbs g-aiPointText"
      style="top:68.2814%;margin-top:-9.2px;left:20.9502%;margin-left:-15.5px;width:31px;"
    >
      <p class="g-pstyle3">3</p>
    </div>
  </div>
  <!-- Artboard: md -->
  <div
    id="g-post14-refinery-md"
    class="g-artboard"
    style="min-width: 660px;max-width: 929px;aspect-ratio: 0.67891848488953;"
    data-aspect-ratio="0.679"
    data-min-width="660"
    data-max-width="929"
  >
    <div
      id="g-post14-refinery-md-img"
      class="g-post14-refinery-md-img g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/post14-refinery-md.jpg);"
    ></div>
    <div
      id="g-ai2-10"
      class="g-text g-aiAbs g-aiPointText"
      style="top:72.0748%;margin-top:-9.7px;left:12.6613%;width:84px;"
    >
      <p class="g-pstyle1">Acid rain</p>
    </div>
    <div
      id="g-ai2-3"
      class="g-text g-aiAbs g-aiPointText"
      style="top:13.8524%;margin-top:-18.7px;left:14.8041%;width:186px;"
    >
      <p class="g-pstyle1">Israeli strikes on Tehran</p>
      <p class="g-pstyle1">oil facilities</p>
    </div>
    <div
      id="g-ai2-7"
      class="g-text g-aiAbs"
      style="top:37.9577%;left:56.8936%;width:41.0606%;"
    >
      <p class="g-pstyle4">
        The burning oil sent a towering black plume into the sky, releasing
        massive amounts of toxic hydrocarbons along with sulfur and nitrogen
        oxides into the lower atmosphere.
      </p>
    </div>
    <div
      id="g-ai2-5"
      class="g-text g-aiAbs g-aiPointText"
      style="top:34.4257%;margin-top:-9.7px;left:34.284%;width:185px;"
    >
      <p class="g-pstyle3">Oil refineries and depots</p>
    </div>
    <div
      id="g-ai2-6"
      class="g-text g-aiAbs"
      style="top:37.8548%;left:4.3406%;width:41.5152%;"
    >
      <p class="g-pstyle4">
        On the night of March 7&ndash;8, 2026, Israeli airstrikes hit multiple
        fuel depots and refineries across Tehran and the neighboring Alborz
        province, igniting vast pools of crude oil and refined fuel.
      </p>
    </div>
    <div
      id="g-ai2-11"
      class="g-text g-aiAbs g-aiPointText"
      style="top:88.842%;margin-top:-9.7px;left:49.3493%;width:68px;"
    >
      <p class="g-pstyle3">Tehran</p>
    </div>
    <div
      id="g-ai2-12"
      class="g-text g-aiAbs"
      style="top:92.6827%;left:4.3406%;width:92.7273%;"
    >
      <p class="g-pstyle4">
        As the toxic plume spread across Tehran, sulfur dioxide and nitrogen
        dioxide combined with moisture in the air, producing dangerous acid
        rain. Authorities warned residents to stay indoors as dense pollution
        and falling rain carried corrosive chemicals across the city.
      </p>
    </div>
    <div
      id="g-ai2-9"
      class="g-blackshadow g-aiAbs g-aiPointText"
      style="top:62.1996%;margin-top:-9.7px;left:36.9818%;width:173px;"
    >
      <p class="g-pstyle2">Dense pollution cloud</p>
    </div>
    <div
      id="g-ai2-4"
      class="g-blackshadow g-aiAbs g-aiPointText"
      style="top:12.9266%;margin-top:-9.7px;left:57.3813%;width:153px;"
    >
      <p class="g-pstyle2">Toxic smoke plume</p>
    </div>
    <div
      id="g-ai2-2"
      class="g-numbersc g-aiAbs g-aiPointText"
      style="top:8.1476%;margin-top:-9.2px;left:64.9541%;margin-left:-15.5px;width:31px;"
    >
      <p class="g-pstyle0">2</p>
    </div>
    <div
      id="g-ai2-8"
      class="g-numbersc g-aiAbs g-aiPointText"
      style="top:62.0496%;margin-top:-9.2px;left:29.1721%;margin-left:-15.5px;width:31px;"
    >
      <p class="g-pstyle0">3</p>
    </div>
    <div
      id="g-ai2-1"
      class="g-numbersc g-aiAbs g-aiPointText"
      style="top:8.1476%;margin-top:-9.2px;left:26.6165%;margin-left:-14.5px;width:29px;"
    >
      <p class="g-pstyle0">1</p>
    </div>
  </div>
  <!-- Artboard: lg -->
  <div
    id="g-post14-refinery-lg"
    class="g-artboard"
    style="min-width: 930px;max-width: 1199px;aspect-ratio: 0.96823384290616;"
    data-aspect-ratio="0.968"
    data-min-width="930"
    data-max-width="1199"
  >
    <div
      id="g-post14-refinery-lg-img"
      class="g-post14-refinery-lg-img g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/post14-refinery-lg.jpg);"
    ></div>
    <div
      id="g-ai3-10"
      class="g-text g-aiAbs g-aiPointText"
      style="top:72.7387%;margin-top:-9.7px;left:22.1956%;width:84px;"
    >
      <p class="g-pstyle1">Acid rain</p>
    </div>
    <div
      id="g-ai3-3"
      class="g-text g-aiAbs g-aiPointText"
      style="top:13.9159%;margin-top:-18.7px;left:23.7162%;width:186px;"
    >
      <p class="g-pstyle1">Israeli strikes on Tehran</p>
      <p class="g-pstyle1">oil facilities</p>
    </div>
    <div
      id="g-ai3-7"
      class="g-text g-aiAbs"
      style="top:38.2088%;left:53.5862%;width:29.1398%;"
    >
      <p class="g-pstyle4">
        The burning oil sent a towering black plume into the sky, releasing
        massive amounts of toxic hydrocarbons along with sulfur and nitrogen
        oxides into the lower atmosphere.
      </p>
    </div>
    <div
      id="g-ai3-5"
      class="g-text g-aiAbs g-aiPointText"
      style="top:34.634%;margin-top:-9.7px;left:37.5407%;width:185px;"
    >
      <p class="g-pstyle3">Oil refineries and depots</p>
    </div>
    <div
      id="g-ai3-6"
      class="g-text g-aiAbs"
      style="top:38.1047%;left:16.2905%;width:29.4624%;"
    >
      <p class="g-pstyle4">
        On the night of March 7&ndash;8, 2026, Israeli airstrikes hit multiple
        fuel depots and refineries across Tehran and the neighboring Alborz
        province, igniting vast pools of crude oil and refined fuel.
      </p>
    </div>
    <div
      id="g-ai3-11"
      class="g-text g-aiAbs g-aiPointText"
      style="top:89.813%;margin-top:-9.7px;left:48.2321%;width:68px;"
    >
      <p class="g-pstyle3">Tehran</p>
    </div>
    <div
      id="g-ai3-12"
      class="g-text g-aiAbs"
      style="top:93.5959%;left:16.2905%;width:65.8065%;"
    >
      <p class="g-pstyle4">
        As the toxic plume spread across Tehran, sulfur dioxide and nitrogen
        dioxide combined with moisture in the air, producing dangerous acid
        rain. Authorities warned residents to stay indoors as dense pollution
        and falling rain carried corrosive chemicals across the city.
      </p>
    </div>
    <div
      id="g-ai3-9"
      class="g-blackshadow g-aiAbs g-aiPointText"
      style="top:62.7441%;margin-top:-9.7px;left:39.4552%;width:173px;"
    >
      <p class="g-pstyle2">Dense pollution cloud</p>
    </div>
    <div
      id="g-ai3-4"
      class="g-blackshadow g-aiAbs g-aiPointText"
      style="top:12.9789%;margin-top:-9.7px;left:53.9323%;width:153px;"
    >
      <p class="g-pstyle2">Toxic smoke plume</p>
    </div>
    <div
      id="g-ai3-2"
      class="g-numbersc g-aiAbs g-aiPointText"
      style="top:8.142%;margin-top:-9.2px;left:59.3065%;margin-left:-15.5px;width:31px;"
    >
      <p class="g-pstyle0">2</p>
    </div>
    <div
      id="g-ai3-8"
      class="g-numbersc g-aiAbs g-aiPointText"
      style="top:62.5922%;margin-top:-9.2px;left:33.9129%;margin-left:-15.5px;width:31px;"
    >
      <p class="g-pstyle0">3</p>
    </div>
    <div
      id="g-ai3-1"
      class="g-numbersc g-aiAbs g-aiPointText"
      style="top:8.142%;margin-top:-9.2px;left:32.0992%;margin-left:-14.5px;width:29px;"
    >
      <p class="g-pstyle0">1</p>
    </div>
  </div>
  <!-- Artboard: xl -->
  <div
    id="g-post14-refinery-xl"
    class="g-artboard"
    style="min-width: 1200px;aspect-ratio: 2.22752964210121;"
    data-aspect-ratio="2.228"
    data-min-width="1200"
  >
    <div
      id="g-post14-refinery-xl-img"
      class="g-post14-refinery-xl-img g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/post14-refinery-xl.jpg);"
    ></div>
    <div
      id="g-ai4-10"
      class="g-text g-aiAbs"
      style="top:74.9935%;left:1.114%;width:21.9167%;"
    >
      <p class="g-pstyle4">
        On the night of March 7&ndash;8, 2026, Israeli airstrikes hit multiple
        fuel depots and refineries across Tehran and the neighboring Alborz
        province, igniting vast pools of crude oil and refined fuel.
      </p>
    </div>
    <div
      id="g-ai4-9"
      class="g-text g-aiAbs g-aiPointText"
      style="top:68.0629%;margin-top:-9.7px;left:71.7808%;width:68px;"
    >
      <p class="g-pstyle3">Tehran</p>
    </div>
    <div
      id="g-ai4-8"
      class="g-text g-aiAbs g-aiPointText"
      style="top:67.1348%;margin-top:-9.7px;left:13.4908%;width:185px;"
    >
      <p class="g-pstyle3">Oil refineries and depots</p>
    </div>
    <div
      id="g-ai4-5"
      class="g-text g-aiAbs g-aiPointText"
      style="top:29.8237%;margin-top:-18.7px;left:1.1139%;width:186px;"
    >
      <p class="g-pstyle2">Israeli strikes on Tehran</p>
      <p class="g-pstyle2">oil facilities</p>
    </div>
    <div
      id="g-ai4-7"
      class="g-text g-aiAbs g-aiPointText"
      style="top:37.2488%;margin-top:-9.7px;left:54.1799%;width:84px;"
    >
      <p class="g-pstyle2">Acid rain</p>
    </div>
    <div
      id="g-ai4-11"
      class="g-text g-aiAbs"
      style="top:74.9935%;left:25.4461%;width:21.0833%;"
    >
      <p class="g-pstyle4">
        The burning oil sent a towering black plume into the sky, releasing
        massive amounts of toxic hydrocarbons along with sulfur and nitrogen
        oxides into the lower atmosphere.
      </p>
    </div>
    <div
      id="g-ai4-12"
      class="g-text g-aiAbs"
      style="top:74.9935%;left:59.0756%;width:34.5833%;"
    >
      <p class="g-pstyle4">
        As the toxic plume spread across Tehran, sulfur dioxide and nitrogen
        dioxide combined with moisture in the air, producing dangerous acid
        rain. Authorities warned residents to stay indoors as dense pollution
        and falling rain carried corrosive chemicals across the city.
      </p>
    </div>
    <div
      id="g-ai4-4"
      class="g-blackshadow g-aiAbs g-aiPointText"
      style="top:19.9854%;margin-top:-9.7px;left:58.2423%;width:173px;"
    >
      <p class="g-pstyle1">Dense pollution cloud</p>
    </div>
    <div
      id="g-ai4-6"
      class="g-blackshadow g-aiAbs g-aiPointText"
      style="top:28.153%;margin-top:-9.7px;left:26.1943%;width:153px;"
    >
      <p class="g-pstyle1">Toxic smoke plume</p>
    </div>
    <div
      id="g-ai4-2"
      class="g-numbersc g-aiAbs g-aiPointText"
      style="top:19.529%;margin-top:-9.2px;left:26.6178%;margin-left:-15.5px;width:31px;"
    >
      <p class="g-pstyle0">2</p>
    </div>
    <div
      id="g-ai4-3"
      class="g-numbersc g-aiAbs g-aiPointText"
      style="top:19.529%;margin-top:-9.2px;left:54.7803%;margin-left:-15.5px;width:31px;"
    >
      <p class="g-pstyle0">3</p>
    </div>
    <div
      id="g-ai4-1"
      class="g-numbersc g-aiAbs g-aiPointText"
      style="top:19.529%;margin-top:-9.2px;left:1.7908%;margin-left:-14.5px;width:29px;"
    >
      <p class="g-pstyle0">1</p>
    </div>
  </div>
</div>

<!-- End ai2svelte - 2026-03-10 14:44 -->

<!-- Generated by ai2svelte v1.0.3 - 2026-03-10 14:44 -->
<!-- ai file: post14-refinery.ai -->
<style lang="scss">
  #g-post14-refinery-box {
    container-type: inline-size;
    container-name: g-post14-refinery-box;
  }
  #g-post14-refinery-box,
  #g-post14-refinery-box .g-artboard {
    margin: 0 auto;
  }
  #g-post14-refinery-box p {
    margin: 0;
  }
  #g-post14-refinery-box .g-aiAbs {
    position: absolute;
  }
  #g-post14-refinery-box .g-aiImg {
    position: absolute;
    top: 0;
    display: block;
    width: 100% !important;
    height: 100%;
    background-size: contain;
    background-repeat: no-repeat;
  }
  #g-post14-refinery-box .g-aiSymbol {
    position: absolute;
    box-sizing: border-box;
  }
  #g-post14-refinery-box .g-aiPointText p {
    white-space: nowrap;
  }
  #g-post14-refinery-box.g-aiPointText p {
    white-space: nowrap;
  }
  #g-post14-refinery-box {
    width: 100%;
    container-type: inline-size;
    @container (min-width:0px) and (max-width: 509px) {
      #g-post14-refinery-xs {
        display: block !important;
      }
    }
    @container (min-width:510px) and (max-width: 659px) {
      #g-post14-refinery-sm {
        display: block !important;
      }
    }
    @container (min-width:660px) and (max-width: 929px) {
      #g-post14-refinery-md {
        display: block !important;
      }
    }
    @container (min-width:930px) and (max-width: 1199px) {
      #g-post14-refinery-lg {
        display: block !important;
      }
    }
    @container (min-width:1200px) {
      #g-post14-refinery-xl {
        display: block !important;
      }
    }
  }
  #g-post14-refinery-xs {
    position: relative;
    overflow: hidden;
    display: none;
  }
  #g-post14-refinery-xs p {
    font-family: var(--theme-font-family-sans-serif), Knowledge, sans-serif;
    font-weight: regular;
    line-height: 16px;
    opacity: 1;
    letter-spacing: 0em;
    font-size: 15px;
    text-align: left;
    color: rgb(64, 64, 64);
    text-transform: none;
    padding-bottom: 0;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    height: auto;
    position: static;
  }
  #g-post14-refinery-xs .g-pstyle0 {
    font-weight: 900;
    line-height: 17px;
    height: 17px;
    font-size: 17px;
    text-align: center;
    color: rgb(255, 255, 255);
  }
  #g-post14-refinery-xs .g-pstyle1 {
    font-weight: 700;
    line-height: 18px;
    height: 18px;
    font-size: 16px;
  }
  #g-post14-refinery-xs .g-pstyle2 {
    font-weight: 400;
    line-height: 18px;
    height: 18px;
    text-align: center;
  }
  #g-post14-refinery-xs .g-pstyle3 {
    font-weight: 400;
  }
  #g-post14-refinery-xs .g-pstyle4 {
    font-weight: 700;
    line-height: 18px;
    height: 18px;
    font-size: 16px;
    color: rgb(255, 255, 255);
  }
  #g-post14-refinery-xs .g-pstyle5 {
    font-weight: 400;
    line-height: 18px;
    height: 18px;
    font-size: 16px;
  }
  #g-post14-refinery-sm {
    position: relative;
    overflow: hidden;
    display: none;
  }
  #g-post14-refinery-sm p {
    font-family: var(--theme-font-family-sans-serif), Knowledge, sans-serif;
    font-weight: regular;
    line-height: 16px;
    opacity: 1;
    letter-spacing: 0em;
    font-size: 15px;
    text-align: left;
    color: rgb(64, 64, 64);
    text-transform: none;
    padding-bottom: 0;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    height: auto;
    position: static;
  }
  #g-post14-refinery-sm .g-pstyle0 {
    font-weight: 700;
    line-height: 18px;
    height: 18px;
    font-size: 16px;
  }
  #g-post14-refinery-sm .g-pstyle1 {
    font-weight: 400;
    line-height: 18px;
    height: 18px;
    text-align: center;
  }
  #g-post14-refinery-sm .g-pstyle2 {
    font-weight: 400;
  }
  #g-post14-refinery-sm .g-pstyle3 {
    font-weight: 900;
    line-height: 17px;
    height: 17px;
    font-size: 17px;
    text-align: center;
    color: rgb(255, 255, 255);
  }
  #g-post14-refinery-sm .g-pstyle4 {
    font-weight: 700;
    line-height: 18px;
    height: 18px;
    font-size: 16px;
    color: rgb(255, 255, 255);
  }
  #g-post14-refinery-sm .g-pstyle5 {
    font-weight: 400;
    line-height: 18px;
    height: 18px;
    font-size: 16px;
  }
  #g-post14-refinery-md {
    position: relative;
    overflow: hidden;
    display: none;
  }
  #g-post14-refinery-md p {
    font-family: var(--theme-font-family-sans-serif), Knowledge, sans-serif;
    font-weight: regular;
    line-height: 18px;
    opacity: 1;
    letter-spacing: 0em;
    font-size: 16px;
    text-align: left;
    color: rgb(64, 64, 64);
    text-transform: none;
    padding-bottom: 0;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    height: auto;
    position: static;
  }
  #g-post14-refinery-md .g-pstyle0 {
    font-weight: 900;
    line-height: 17px;
    height: 17px;
    font-size: 17px;
    text-align: center;
    color: rgb(255, 255, 255);
  }
  #g-post14-refinery-md .g-pstyle1 {
    font-weight: 700;
    height: 18px;
  }
  #g-post14-refinery-md .g-pstyle2 {
    font-weight: 700;
    height: 18px;
    color: rgb(255, 255, 255);
  }
  #g-post14-refinery-md .g-pstyle3 {
    font-weight: 400;
    height: 18px;
  }
  #g-post14-refinery-md .g-pstyle4 {
    font-weight: 400;
  }
  #g-post14-refinery-lg {
    position: relative;
    overflow: hidden;
    display: none;
  }
  #g-post14-refinery-lg p {
    font-family: var(--theme-font-family-sans-serif), Knowledge, sans-serif;
    font-weight: regular;
    line-height: 18px;
    opacity: 1;
    letter-spacing: 0em;
    font-size: 16px;
    text-align: left;
    color: rgb(64, 64, 64);
    text-transform: none;
    padding-bottom: 0;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    height: auto;
    position: static;
  }
  #g-post14-refinery-lg .g-pstyle0 {
    font-weight: 900;
    line-height: 17px;
    height: 17px;
    font-size: 17px;
    text-align: center;
    color: rgb(255, 255, 255);
  }
  #g-post14-refinery-lg .g-pstyle1 {
    font-weight: 700;
    height: 18px;
  }
  #g-post14-refinery-lg .g-pstyle2 {
    font-weight: 700;
    height: 18px;
    color: rgb(255, 255, 255);
  }
  #g-post14-refinery-lg .g-pstyle3 {
    font-weight: 400;
    height: 18px;
  }
  #g-post14-refinery-lg .g-pstyle4 {
    font-weight: 400;
  }
  #g-post14-refinery-xl {
    position: relative;
    overflow: hidden;
    display: none;
  }
  #g-post14-refinery-xl p {
    font-family: var(--theme-font-family-sans-serif), Knowledge, sans-serif;
    font-weight: regular;
    line-height: 18px;
    opacity: 1;
    letter-spacing: 0em;
    font-size: 16px;
    text-align: left;
    color: rgb(64, 64, 64);
    text-transform: none;
    padding-bottom: 0;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    height: auto;
    position: static;
  }
  #g-post14-refinery-xl .g-pstyle0 {
    font-weight: 900;
    line-height: 17px;
    height: 17px;
    font-size: 17px;
    text-align: center;
    color: rgb(255, 255, 255);
  }
  #g-post14-refinery-xl .g-pstyle1 {
    font-weight: 700;
    height: 18px;
    color: rgb(255, 255, 255);
  }
  #g-post14-refinery-xl .g-pstyle2 {
    font-weight: 700;
    height: 18px;
  }
  #g-post14-refinery-xl .g-pstyle3 {
    font-weight: 400;
    height: 18px;
  }
  #g-post14-refinery-xl .g-pstyle4 {
    font-weight: 400;
  }

  /* Custom CSS */
  @mixin shadow-emmental($clr) {
    $alpha: if(alpha($clr) != 1, alpha($clr), 1);
    text-shadow:
      -1px 0 rgba($clr, $alpha),
      0 1px rgba($clr, $alpha),
      1px 0 rgba($clr, $alpha),
      0 -1px rgba($clr, $alpha);
  }
  .g-blackshadow {
    @include shadow-emmental(#000000);
  }
  .g-numbersc {
    background-color: #000000;
    border-radius: 50%;
    border: 1px solid #ffffff;
    aspect-ratio: 1;
    width: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #ffffff;
  }
</style>
